import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { BaseWebService } from "../../services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class ActionRequiredListServcie {
    constructor(
        private _baseWebService: BaseWebService
    ) {
    }

    approvalListService(limit: number, offset: number) {
        return this._baseWebService.request("v1/treatment_approval/?limit=" + limit + "&offset=" + offset + "&status=waiting", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    followUpCommunicationService(limit: number, offset: number, sortParam: any, order: any) {
        let url = "v1/action_required_list/?limit=" + limit + "&offset=" + offset;

        if (sortParam && order) {
            url = url + "&sort=" + sortParam + "&order=" + order;
        }

        return this._baseWebService.request(url, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    updateAutomation(id: number, value: boolean) {
        return this._baseWebService.request("v1/action_required_list/?id=" + id + "&value=" + value, "put")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    sendTrigger(triggerData: any) {
        const data: any = {};
        data.body = triggerData;

        return this._baseWebService.request("v1/action_required_list/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    // non start follow up untrack
    cancelNonStartFollowupTracking(id: any) {
        const data: any = {};
        data.body = { is_in_follow_up: false };
        return this._baseWebService.request("v1/non_start_followup_communications/" + id + "/untrack/", "put", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}